import React from 'react'
import '../css/styles.css';
import {Link} from 'react-router-dom';

export default function Scaleup() {
  return (
    <>
       <section id="about" className="about section-bg" style={{borderBottom: "2px solid #13364a"}}>
        <div className="container aos-init aos-animate" data-aos="fade-up">
  
           <div id="about-vision" className="row">
          
            <div id="vision-left" className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
              <h3>A Place where we help you <br />
                to build your Dream Products</h3>
              <p className="font-regular">
                With our expertise Go from idea to product to market <br /> 
                10x faster &amp; less cost than ever before
              </p>
              <span><Link className="btn" to="/aboutus" id="about-vision-btn">EXPLORE</Link></span>
            </div>
            <div id="scale-right" class="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
              <h3 style={{color: "white"}}>Want to scale up your production from 
                prototyping to mass production phase ?
              </h3>
              <p class="font-regular" style={{color: "white"}}>
                We help you do it with our versatile <br /> infrastructure
              </p>
              <span><Link className="btn" to="/aboutus" id="about-scale-btn">EXPLORE</Link></span>
            </div>
           
          </div> 
  
        </div>
      </section>
    </>
  )
}
